var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"nav"},[_c('div',{staticClass:"nav__wrap-menu"},[_c('Logo',{attrs:{"white":_vm.dark}}),_c('Menu',{attrs:{"white":_vm.dark}})],1),_c('AuthBlock',{attrs:{"show":_vm.authBlock,"dark":_vm.dark,"small":""}}),_c('div',{staticClass:"nav__lang"},[_c('Lang',{attrs:{"dark":_vm.dark}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }